/* Claude 2026-10-19: produktsidan – andra storlekar, fraktfritt-mätare och fast köpknapp på mobil */
(function(){
  if(window.__cpd)return;window.__cpd=1;
  var ROOT=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  var DA=(document.documentElement.lang||'').indexOf('da')===0;
  function money(c){try{return theme.Currency.formatMoney(c,theme.settings.moneyFormat).replace(/[,.]00(?=\D*$)/,'');}catch(e){return Math.round(c/100)+' kr';}}
  function esc(s){var d=document.createElement('div');d.textContent=s==null?'':s;return d.innerHTML;}

  /* ---------- Vikt ur namnet (samma regel som snippets/claude-size) ---------- */
  var WRE=/(\d+(?:[.,]\d+)?)\s*(kg|g)\b/gi;
  function kgOf(t){var m,kg=0;WRE.lastIndex=0;while((m=WRE.exec(t||''))){var n=parseFloat(m[1].replace(',','.'));kg=m[2].toLowerCase()==='kg'?n:n/1000;}return kg;}
  function base(t){return (t||'').replace(WRE,' ').replace(/[()\-–,]/g,' ').replace(/\s+/g,' ').trim().toLowerCase();}
  function kgLabel(kg){return kg<1?Math.round(kg*1000)+' g':String(Math.round(kg*100)/100).replace('.',',')+' kg';}

  /* ---------- Andra storlekar av samma produkt ---------- */
  function initSizes(){
    var box=document.querySelector('[data-cpd-sizes]');if(!box)return;
    var title=box.getAttribute('data-title'),vendor=(box.getAttribute('data-vendor')||'').toLowerCase(),handle=box.getAttribute('data-handle');
    var b=base(title);if(!b)return;
    var q=b.split(' ').filter(function(w){return w.length>1;}).slice(0,6).join(' ');
    fetch(ROOT+'search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last',{credentials:'same-origin'})
      .then(function(r){return r.json();}).then(function(d){
        var ps=((d.resources||{}).results||{}).products||[];
        var list=[],seen={};
        ps.forEach(function(p){
          if(base(p.title)!==b)return;
          if(vendor&&(p.vendor||'').toLowerCase()!==vendor)return;
          var kg=kgOf(p.title);if(!kg||seen[kg])return;seen[kg]=1;
          var cents=Math.round(parseFloat(p.price)*100);
          list.push({kg:kg,url:(p.url||'').split('?')[0],price:cents,ppk:cents/kg,avail:p.available!==false,cur:p.handle===handle});
        });
        if(list.length<2||!list.some(function(x){return x.cur;}))return;
        list.sort(function(a,b){return a.kg-b.kg;});
        var best=null;list.forEach(function(x){if(x.avail&&(!best||x.ppk<best.ppk))best=x;});
        var bestTxt=DA?'Bedste kilopris':'Bäst per kg';
        var showPpk=box.hasAttribute('data-ppk'); /* kilopris bara på Callebaut */
        box.querySelector('[data-cpd-sizes-list]').innerHTML=list.map(function(x){
          var tag=x.cur?'span':'a';
          return '<'+tag+(x.cur?'':' href="'+esc(x.url)+'"')+' class="cpd-size'+(x.cur?' is-on':'')+(x.avail?'':' is-out')+'"'+(x.cur?' aria-current="true"':'')+'>'+
            (showPpk&&best===x&&list.length>2?'<span class="cpd-size__tag">'+bestTxt+'</span>':'')+
            '<strong>'+kgLabel(x.kg)+'</strong><span class="cpd-size__price">'+money(x.price)+'</span>'+(showPpk?'<span class="cpd-size__ppk">'+money(Math.round(x.ppk/100)*100)+'/kg</span>':'')+'</'+tag+'>';
        }).join('');
        box.hidden=false;
      }).catch(function(){});
  }

  /* ---------- Fraktfritt-mätare ---------- */
  function updateFsb(){
    var box=document.querySelector('[data-cpd-fsb]');if(!box)return;
    fetch(ROOT+'cart.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(c){
      var th=+box.getAttribute('data-threshold')||69900,left=th-c.total_price;
      box.querySelector('[data-cpd-fsb-msg]').innerHTML=left>0?esc(box.getAttribute('data-t-left')).replace('[amount]','<strong>'+esc(money(left))+'</strong>'):esc(box.getAttribute('data-t-free'));
      box.querySelector('[data-cpd-fsb-bar]').style.width=Math.min(100,Math.round(c.total_price*100/th))+'%';
    }).catch(function(){});
  }
  ['cart:build','cart:updated','ajaxProduct:added'].forEach(function(ev){document.addEventListener(ev,function(){setTimeout(updateFsb,400);});});

  /* ---------- Fast köpknapp på mobil ---------- */
  function initSticky(){
    var bar=document.querySelector('[data-cpd-sticky]');
    var SEL='.product-section .product-single__form .add-to-cart';
    if(!bar||!document.querySelector(SEL))return;
    document.body.appendChild(bar);
    var btn=bar.querySelector('[data-cpd-sticky-btn]'),label=btn.textContent,on=null,tick=false;
    /* Knappen hämtas på nytt varje gång – temat kan byta ut köpformuläret efter att sidan laddat */
    btn.addEventListener('click',function(){var real=document.querySelector(SEL);if(real&&!real.disabled)real.click();});
    function check(){
      tick=false;
      var real=document.querySelector(SEL);if(!real)return;
      var past=real.getBoundingClientRect().bottom<0;
      btn.disabled=!!real.disabled;btn.textContent=real.disabled?(real.textContent||'').trim():label;
      if(past===on)return;on=past;
      if(past){bar.hidden=false;requestAnimationFrame(function(){bar.classList.add('is-on');});}
      else{bar.classList.remove('is-on');}
      document.documentElement.classList.toggle('cpd-sticky-on',past);
    }
    window.addEventListener('scroll',function(){if(!tick){tick=true;requestAnimationFrame(check);}},{passive:true});
    window.addEventListener('resize',check);
    bar.addEventListener('transitionend',function(){if(!bar.classList.contains('is-on'))bar.hidden=true;});
    check();
  }

  /* ---------- Stjärnorna vid rubriken leder till recensionerna längre ner ---------- */
  document.addEventListener('click',function(e){
    var b=e.target.closest('.product-section .jdgm-prev-badge');if(!b)return;
    var t=document.querySelector('[data-claude-reviews-section]');if(!t)return;
    e.preventDefault();e.stopPropagation();
    function go(sm){window.scrollTo({top:t.getBoundingClientRect().top+window.pageYOffset-90,behavior:sm?'smooth':'auto'});}
    go(true);
    /* "Passar bra till" laddas in på vägen och flyttar ner recensionerna – justera när det är klart */
    setTimeout(function(){if(Math.abs(t.getBoundingClientRect().top-90)>30)go(true);},900);
  },true);

  function boot(){initSizes();initSticky();updateFsb();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();
